import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.object.assign";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Sortable from 'sortablejs';
import ApiService from '@/services/apiService';
import { get, isObject, cloneDeep } from 'lodash';
import { getFileURL } from '../../../utils/file-uploads';
import dataSourcesListMixin from '@/components/core/dtwin/state/dataSourcesListMixin';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
var excludedKeys = ['_raw', '_parsed', '_health'];
export default {
  name: 'DeviceTemplatesDataStates',
  mixins: [dataSourcesListMixin, iconsMixin],
  props: {
    template: {
      type: Object,
      required: true
    },
    isProductiveVersion: {
      type: Boolean,
      optional: true,
      default: false
    },
    templateInformation: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isDataStatesFormValid: true,
      showDeleteDialog: false,
      confirmDeleteKey: null,
      deviceDriver: null,
      tableOptions: _objectSpread({}, defaultTableOptions),
      targetVariables: [],
      bridgeConfigs: [],
      stateEditItem: null,
      stateEditDialog: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    themeMode: function themeMode() {
      return Boolean(this.$store.state.app.UiTheme) ? 'dark' : 'light';
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.targetVariable')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.type')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.unit')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.addState'),
          align: 'center'
        }],
        dataStatesHeaders: [{
          text: ''
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.icon')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.title')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.type')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.unit')
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.source'),
          align: 'center'
        }, {
          text: ''
        }]
      };
    },
    tableItems: function tableItems() {
      var _this = this;

      return Object.keys(this.targetVariables).map(function (key) {
        return {
          properties: {
            key: _this.targetVariables[key].name,
            title: _this.targetVariables[key].name,
            valueType: _this.targetVariables[key].type,
            unit: _this.targetVariables[key].unit
          }
        };
      });
    },
    addedStatesItems: function addedStatesItems() {
      return this.template.stateDefinition || [];
    },
    actionButtons: function actionButtons() {
      return [{
        disabled: this.isProductiveVersion,
        icon: 'fal fa-plus',
        action: 'addItem',
        title: this.$i18n_t('Common.add'),
        tooltip: this.$i18n_t('Common.addNew')
      }];
    },
    dataStatesHeaders: function dataStatesHeaders() {
      return this.isProductiveVersion ? this.tableLocalizations.dataStatesHeaders.slice(1) : this.tableLocalizations.dataStatesHeaders;
    }
  }),
  watch: {
    template: {
      handler: function handler() {
        if (!this.template || !this.template.deviceDriverId) {
          return;
        }

        this.loadDeviceDriverDetails();
        this.loadBridgeConfigs();
      },
      immediate: true
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.initSortableTable();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    onStateEditUpdate: function onStateEditUpdate(newState) {
      this.stateEditItem = newState;
    },
    loadDeviceDriverDetails: function () {
      var _loadDeviceDriverDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var deviceDriverId;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deviceDriverId = this.template.deviceDriverId;
                _context2.prev = 1;
                _context2.next = 4;
                return ApiService.virtualDeviceDrivers.fetchOneById(deviceDriverId);

              case 4:
                this.deviceDriver = _context2.sent;
                this.targetVariables = this.getTargetVariables(this.deviceDriver);
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                this.$snack(get(_context2.t0, 'response.data.err') || this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.snacks.fetchDeviceDriverFailed'), 'error');

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));

      function loadDeviceDriverDetails() {
        return _loadDeviceDriverDetails.apply(this, arguments);
      }

      return loadDeviceDriverDetails;
    }(),
    getTargetVariables: function getTargetVariables(deviceDriver) {
      var driverVersion = deviceDriver.versions[0];
      var parserVariables = get(driverVersion, 'parser.config.variables', {});
      var isMultiParser = get(driverVersion, 'parser.type') === 'multi';

      if (isMultiParser) {
        parserVariables = {};
        var parserKeys = Object.keys(get(driverVersion, 'parser.config') || {}).filter(function (k) {
          return k !== '__switch';
        });
        parserKeys.forEach(function (pKey) {
          var parserVariablesOfKey = get(driverVersion, "parser.config.".concat(pKey, ".variables"));

          if (isObject(parserVariablesOfKey)) {
            Object.assign(parserVariables, parserVariablesOfKey);
          }
        });
      }

      var mappedParserVariables = Object.keys(parserVariables).filter(function (key) {
        return !excludedKeys.includes(key);
      }).map(function (key) {
        return {
          name: parserVariables[key].name,
          type: parserVariables[key].type,
          unit: get(parserVariables[key], 'value_type.name')
        };
      });
      return mappedParserVariables;
    },
    getImageUrl: function getImageUrl(fileId) {
      return getFileURL(fileId, 2);
    },
    addItem: function addItem() {
      this.openStateEditForm();
    },
    openStateEditForm: function openStateEditForm() {
      this.stateEditItem = null;
      this.stateEditDialog = true;
    },
    isStateDeletable: function isStateDeletable(state) {
      return state.key !== '_raw' && state.key !== '_health' && state.key !== '_parsed';
    },
    partOfDataStates: function partOfDataStates(item) {
      return this.template.stateDefinition.find(function (i) {
        return i.properties.bindingVariable === item.properties.title;
      });
    },
    getValueType: function getValueType(unit) {
      if (unit === 'Number') {
        return 'number';
      } else if (unit === 'String') {
        return 'string';
      } else if (unit === 'Boolean') {
        return 'boolean';
      } else if (unit === 'Unset') {
        return 'number';
      } else {
        return 'number';
      }
    },
    addState: function () {
      var _addState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        var itemToAdd;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                itemToAdd = cloneDeep(item);
                itemToAdd.key = item.properties.key;
                itemToAdd.properties = {
                  unit: item.properties.unit,
                  title: item.properties.title,
                  visual: {},
                  binding: {
                    type: 'bridge',
                    options: {
                      variable: item.properties.key,
                      configId: this.template.deviceMeta.connectorId
                    },
                    transformer: {
                      script: 'module.exports = (data) => {\n  return data;\n}'
                    }
                  },
                  valueType: this.getValueType(item.properties.unit),
                  bindingVariable: item.properties.key
                };
                _context3.prev = 3;
                _context3.next = 6;
                return ApiService.deviceTemplateUpdate(this.template);

              case 6:
                this.template.stateDefinition.push(itemToAdd);
                this.$emit('update-unsaved-changes', this.template);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.stateAdded', {
                  key: itemToAdd.key
                }), 'success');
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](3);
                this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.stateAddingFailed', {
                  key: itemToAdd.key
                }), 'error');

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 11]]);
      }));

      function addState(_x) {
        return _addState.apply(this, arguments);
      }

      return addState;
    }(),
    openEditDialog: function openEditDialog() {
      this.showDeleteDialog = true;
    },
    handleConfirmDelete: function () {
      var _handleConfirmDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.template.stateDefinition = this.template.stateDefinition.filter(function (state) {
                  return state.key !== _this2.confirmDeleteKey;
                });
                _context4.prev = 1;
                _context4.next = 4;
                return ApiService.deviceTemplateUpdate(this.template);

              case 4:
                this.$emit('update-unsaved-changes', this.template);
                this.showDeleteDialog = false;
                this.$snack(this.$i18n_t('DigitalTwin.DigitalTwin.states.deleted') + this.confirmDeleteKey, 'success');
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);

                if (_context4.t0.response && this.$i18n_t("Error.".concat(_context4.t0.response.data.message))) {
                  this.$snack(this.$i18n_t("Error.".concat(_context4.t0.response.data.message)), 'error');
                } else {
                  this.$snack('Could not delete state', 'error');
                }

              case 12:
                _context4.prev = 12;
                this.confirmDeleteKey = null;
                return _context4.finish(12);

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 9, 12, 15]]);
      }));

      function handleConfirmDelete() {
        return _handleConfirmDelete.apply(this, arguments);
      }

      return handleConfirmDelete;
    }(),
    loadBridgeConfigs: function () {
      var _loadBridgeConfigs = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ApiService.getBridgesForTenant(this.template.tenantId).then(function (configs) {
                  _this3.bridgeConfigs = configs.filter(function (config) {
                    return config.id === get(_this3.template, 'deviceMeta.connectorId');
                  }).map(function (config) {
                    return {
                      type: config.type,
                      image: _this3.bridgeTypesIcons[config.type],
                      title: config.name,
                      configId: config.id,
                      tenantId: config.tenantId
                    };
                  });
                }).catch(function (error) {
                  console.error('Error', error);
                });

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadBridgeConfigs() {
        return _loadBridgeConfigs.apply(this, arguments);
      }

      return loadBridgeConfigs;
    }(),
    bridgeConfig: function bridgeConfig(bridge, types) {
      var foundMatch = types.find(function (config) {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    editState: function editState(item) {
      if (item.key === '_health') {
        var baseUrl = window.location.href.split('?')[0];
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set('tab', 'tab-health-configuration');
        window.location.href = "".concat(baseUrl, "?").concat(queryParams.toString());
        return;
      }

      var indexOfEditedElement = this.template.stateDefinition.findIndex(function (el) {
        return el.key === item.key;
      });
      this.stateEditItem = item;
      this.stateEditItem.indexOfEditedElement = indexOfEditedElement;
      this.stateEditDialog = true;
    },
    deleteState: function deleteState(key) {
      this.confirmDeleteKey = key;
      this.showDeleteDialog = true;
    },
    closeEditWithError: function closeEditWithError(errorMessage) {
      if (errorMessage) {
        this.$snack(errorMessage, 'error');
      }

      this.stateEditDialog = false;
      this.stateEditItem = null;
    },
    saveState: function () {
      var _saveState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(stateDetails) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (stateDetails.indexOfEditedElement || stateDetails.indexOfEditedElement === 0) {
                  this.template.stateDefinition.splice(stateDetails.indexOfEditedElement, 1, stateDetails);
                } else {
                  this.template.stateDefinition.push(stateDetails);
                }

                _context6.next = 3;
                return ApiService.deviceTemplateUpdate(this.template);

              case 3:
                this.$emit('update-unsaved-changes', this.template);
                this.stateEditDialog = false;

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function saveState(_x2) {
        return _saveState.apply(this, arguments);
      }

      return saveState;
    }(),
    initSortableTable: function initSortableTable() {
      var _this4 = this;

      var table = document.querySelector('.states-table tbody');
      Sortable.create(table, {
        handle: '.handle',
        onEnd: function onEnd(_ref) {
          var _this4$template$state;

          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          (_this4$template$state = _this4.template.stateDefinition).splice.apply(_this4$template$state, [newIndex, 0].concat(_toConsumableArray(_this4.template.stateDefinition.splice(oldIndex, 1))));
        }
      });
    }
  }
};